module.exports = __webpack_public_path__ + "static/bro10-8b961fc236f9d2a1753417f6ed9b8631.jpg";